module.exports = __webpack_public_path__ + "static/media/specific-risk-not-purchased-dna.7fc9563c.svg";